import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {LayoutComponent} from './layout/layout.component';
import {ResourcesResolver} from '../core/resolvers/resources.resolver';
import {MarketSeoComponent} from '@app/market-seo/market-seo.component';
import {AuthGuard} from '@app/guards/auth.guard';
import {CheckoutMarketGuard} from '@app/guards/chekout.market.guard';
import {CategoryTreeResolver } from '../core/resolvers/category-tree.resolver';

const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    resolve: {resource: ResourcesResolver, categoryTree: CategoryTreeResolver},
    children: [
      {path: '', component: MarketSeoComponent},
      {
        path: 'pedidos',
        canActivate: [AuthGuard],
        data: {route: 'market/pedidos'},
        loadChildren: () =>
          import('../orders/orders.module').then((m) => m.OrdersModule),
      },
      {
        path: 'productos-compras-cuba-online',
        canActivate: [],
        data: {roles: []},
        loadChildren: () =>
          import('../products/products.module').then((m) => m.ProductsModule),
      },
      {
        path: 'revisar-completar-pedido',
        canActivate: [AuthGuard, CheckoutMarketGuard],
        data: {route: 'market/revisar-completar-pedido'},
        loadChildren: () =>
          import('../checkout/checkout.module').then((m) => m.CheckoutModule),
      },
      {
        path: 'ofertas-descuentos-tienda-envios-cuba',
        canActivate: [],
        data: {roles: []},
        loadChildren: () =>
          import('../products/products.module').then((m) => m.ProductsModule),
      },
      {
        path: 'tiendas-asociadas',
        canActivate: [],
        data: {roles: []},
        loadChildren: () =>
          import('../stores/stores.module').then((m) => m.StoresModule),
      },
      {
        path: 'tiendas-asociadas/:id/productos',
        canActivate: [],
        data: {roles: []},
        loadChildren: () =>
          import('../products/products.module').then((m) => m.ProductsModule),
      },
      {
        path: 'tienda-online-cuba',
        canActivate: [],
        data: {roles: []},
        children: [
          {
            path: '',
            loadChildren: () => import('../../marketplace/categories/categories.module').then(m => m.CategoriesModule)
          },
          {
            path: ':id',
            loadChildren: () =>
              import('../products/products.module').then((m) => m.ProductsModule),
          },
          {path: '**', redirectTo: '', pathMatch: 'full'},
        ],
      },
      {
        path: 'vender-mercado-online-cuba',
        canActivate: [],
        data: {roles: []},
        loadChildren: () => import('../../market-supplier/market-supplier.module').then(m => m.MarketSupplierModule)
      },
      {
        path: 'envios/amazon-para-cuba',
        canActivate: [],
        data: {roles: []},
        loadChildren: () => import('../../market-amazon/market-amazon.module').then(m => m.MarketAmazonModule)
      },
      {
        path: 'envios/shein-para-cuba',
        canActivate: [],
        data: {roles: []},
        loadChildren: () => import('../../market-shein/market-shein.module').then(m => m.MarketSheinModule)
      },
      {
        path: 'envios/walmart-para-cuba',
        canActivate: [],
        data: {roles: []},
        loadChildren: () => import('../../market-walmart/market-walmart.module').then(m => m.MarketWalmartModule)
      },
      {
        path: 'envios/home-depot-para-cuba',
        canActivate: [],
        data: {roles: []},
        loadChildren: () => import('../../market-home-depot/market-home-depot.module').then(m => m.MarketHomeDepotModule)
      },
      {
        path: 'envios/best-buy-para-cuba',
        canActivate: [],
        data: {roles: []},
        loadChildren: () => import('../../market-best-buy/market-best-buy.module').then(m => m.MarketBestBuyModule)
      },
      {
        path: '**',
        redirectTo: 'error/404',
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LayoutRoutingModule {
}
